import { render, staticRenderFns } from "./Referees.vue?vue&type=template&id=a2234976&scoped=true&"
import script from "./Referees.vue?vue&type=script&lang=js&"
export * from "./Referees.vue?vue&type=script&lang=js&"
import style0 from "./Referees.vue?vue&type=style&index=0&id=a2234976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2234976",
  null
  
)

export default component.exports